import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import {formatDate, formatTime } from 'web-common/scripts/utils/DateHelper';
import cls from 'classnames';
import {Col, Row} from 'react-bootstrap';
import BZCarousel from 'web-common/bizzabo-components/components/BZCarousel';
import SessionElement from './SessionElem';
import {L_WIDTH, M_WIDTH, S_WIDTH, XL_WIDTH, XS_WIDTH, XXS_WIDTH, VIEW_MODE_SBS} from '../../../constants/Enums';

const Arrow = (props) => {
    const { className, onClick } = props;
    return (
        <div className={`${className} transparent-arrow`} onClick={onClick}>
            <div className={'sbs-arrow-circle'}>
                <i className="fa icon-SbS_Arrow sbs-arrow"/>
            </div>
        </div>
    );
};

const carouselSettings = {
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    arrows: true,
    dots: false,
    prevArrow: <Arrow />,
    nextArrow: <Arrow />,
    responsive: [
        { breakpoint: XXS_WIDTH, settings: { slidesToShow: 1, slidesToScroll: 1 } },
        { breakpoint: XS_WIDTH, settings: { slidesToShow: 1, slidesToScroll: 1 } },
        { breakpoint: S_WIDTH, settings: { slidesToShow: 1, slidesToScroll: 1 } },
        { breakpoint: M_WIDTH, settings: { slidesToShow: 1, slidesToScroll: 1 } },
        { breakpoint: L_WIDTH },
        { breakpoint: XL_WIDTH},
    ]
};



class SBSItem extends Component {
    static propTypes = {
        session: PropTypes.object.isRequired,
        sessions: PropTypes.array.isRequired,
        settings: PropTypes.object.isRequired,
        siteConf: PropTypes.object.isRequired,
        sessionsMap: PropTypes.object.isRequired,
    };

    state = {
        fetching: false
    }

    componentDidUpdate() {
        const {
            session: { missedSessions },
            getSliderSessions
        } = this.props;
        const { fetching } = this.state;

        if (fetching && missedSessions.length) {
            return;
        }
        if (!missedSessions.length && fetching) {
            this.setState({ fetching: false });
        }
        if (missedSessions.length && !fetching) {
            this.setState({ fetching: true});
            getSliderSessions(missedSessions);
        }
    }

    notScheduledBlock = (isDatesLabelsEnabled, notScheduledLabel) => (
        <span>
            {
                isDatesLabelsEnabled ?
                    notScheduledLabel
                    :
                    <>
                        NOT SCHEDULED, <span className='text-bold'>YET</span>
                    </>
            }
        </span>
    )

    renderDateElement = (session) => {
        const { settings: { datesLabelType, datesLabelMapping }} = this.props;
        const isDatesLabelsEnabled = datesLabelType === 'LABELS';
        const dateOrLabel = isDatesLabelsEnabled ? datesLabelMapping[`day-${session.startDate}`] :this.getFormattedDate(session);
        const notScheduledLabel = isDatesLabelsEnabled && datesLabelMapping['not-scheduled'];
        const isScheduled = session.startDate && session.startMinute >=0;
        return <Row className='day-title-row'>
            <Col lg={12}>
                <span className='day-title'>
                    {
                        isScheduled
                            ? dateOrLabel
                            : this.notScheduledBlock(isDatesLabelsEnabled, notScheduledLabel)
                    }
                </span>
            </Col>
        </Row>;
    };


    getFormattedDate = (session) => {
        const datesFormatArray = this.props.settings.dateFormat.split(' ');
        return datesFormatArray.map((el, i) => <span
            className={cls('event-day-part$', {'week': el === 'ddd'})}
            key={i}>{`${formatDate(session.startDate, el)} `}
        </span>
        );
    };

    render() {
        const {
            settings,
            siteConf: {color1: color},
            session,
            viewMode,
            session: {isOneLineElement, slides, firstUnscheduledSession, shouldShowDate, showTime},
            index,
            shouldStickAgendaSearch,
            setScrollToSessionBroadcastAction
        } = this.props;
        const containerClass = cls('session-elem sessions-time-elem', {
            'padding-horizontal-none': isOneLineElement && slides.length > 1,
            'session-carousel': isOneLineElement && slides.length > 1
        });
        return <Col xs={12} key={session.id}>
            <div className="session-day-container">
                { shouldShowDate && this.renderDateElement(session, firstUnscheduledSession) }
                <Row className="time-row">
                    { showTime && <Col md={1} xs={3} sm={2} className='time-elem'>
                        <div style={{backgroundColor: `var(--page-main-color, ${color})`}}>{formatTime(session.startMinute, settings.timeFormat)}</div>
                    </Col>}
                    <Col md={11} mdOffset={showTime ? 0 : 1} className={containerClass}>

                        {
                            isOneLineElement && slides.length > 1
                                ? <BZCarousel className='sessions-carousel' settings={{ ...carouselSettings, slidesToShow: session.slidesToShow }}>
                                    { slides.map(sliderSession => <SessionElement
                                        key={session.id}
                                        setScrollToSessionBroadcastAction={setScrollToSessionBroadcastAction}
                                        {...{
                                            ...this.props,
                                            session: sliderSession,
                                            elementsToRender: session.elementsToRender,
                                            index,
                                            shouldStickAgendaSearch,
                                            ...{ SBSViewMode: viewMode === VIEW_MODE_SBS && !session.excluded && slides.length && session.slidesToShow}
                                        }}
                                    />)}
                                </BZCarousel>
                                : <SessionElement
                                    elementsToRender={session.elementsToRender}
                                    index={index}
                                    setScrollToSessionBroadcastAction={setScrollToSessionBroadcastAction}
                                    shouldStickAgendaSearch={shouldStickAgendaSearch}
                                    { ...this.props }
                                />
                        }
                    </Col>
                </Row>
            </div>
        </Col>;
    }
}

export default SBSItem;
